// Square Cards
import SquareImageCard1 from '../ArticleCards/Variations/SquareImageCard1';
import SquareImageCard2 from '../ArticleCards/Variations/SquareImageCard2';
import SquareImageCardFull1 from '../ArticleCards/Variations/SquareImageCardFull1';
import SquareImageCoverWithHeadline1 from '../ArticleCards/Variations/SquareImageCoverWithHeadline1';
import SquareImageCoverWithHeadline2 from '../ArticleCards/Variations/SquareImageCoverWithHeadline2';
import SquareQuote1 from '../ArticleCards/Variations/SquareQuote1';
import SquareQuote2 from '../ArticleCards/Variations/SquareQuote2';
import SquareNumberLarge1 from '../ArticleCards/Variations/SquareNumberLarge1';
import SquareNumberLarge2 from '../ArticleCards/Variations/SquareNumberLarge2';
import SquareNumberLarge3 from '../ArticleCards/Variations/SquareNumberLarge3';
import SquareNumberLarge4 from '../ArticleCards/Variations/SquareNumberLarge4';
import SquareParagraphWithTitle1 from '../ArticleCards/Variations/SquareParagraphWithTitle1';

// Portrait Cards
import PortraitImageCard1 from '../ArticleCards/Variations/PortraitImageCard1';
import PortraitImageCard2 from '../ArticleCards/Variations/PortraitImageCard2';
import PortraitImageCard3 from '../ArticleCards/Variations/PortraitImageCard3';
// import PortraitImageCardFull1 from '../ArticleCards/Variations/PortraitImageCardFull1';
import PortraitImageCardFull2 from '../ArticleCards/Variations/PortraitImageCardFull2';
import PortraitTwoImagesWithHeadline1 from '../ArticleCards/Variations/PortraitTwoImagesWithHeadline1';
import PortraitTwoImagesWithHeadline2 from '../ArticleCards/Variations/PortraitTwoImagesWithHeadline2';
import PortraitTwoImagesWithParagraph from '../ArticleCards/Variations/PortraitTwoImagesWithParagraph';
import PortraitParagraphLarge from '../ArticleCards/Variations/PortraitParagraphLarge';
import PortraitParagraphWithTitle1 from '../ArticleCards/Variations/PortraitParagraphWithTitle1';
import PortraitParagraphFull1 from '../ArticleCards/Variations/PortraitParagraphFull1';
import PortraitParagraphFull2 from '../ArticleCards/Variations/PortraitParagraphFull2';
import PortraitParagraphInTwoColumns from '../ArticleCards/Variations/PortraitParagraphInTwoColumns';
import PortraitEndCard from '../ArticleCards/Variations/PortraitEndCard';
import PortraitSocialEmbedInstagram from '../ArticleCards/Variations/PortraitSocialEmbedInstagram';
import PortraitSocialEmbedTwitter from '../ArticleCards/Variations/PortraitSocialEmbedTwitter';
import PortraitSocialEmbedYoutube from '../ArticleCards/Variations/PortraitSocialEmbedYoutube';

// Landscape Cards
import LandscapeImageCard1 from '../ArticleCards/Variations/LandscapeImageCard1';
import LandscapeImageCardFull1 from '../ArticleCards/Variations/LandscapeImageCardFull1';

export default {
  c1: {
    component: SquareImageCoverWithHeadline1
  },
  c2: {
    component: SquareImageCoverWithHeadline2
  },
  c3: {
    component: SquareImageCard1
  },
  c4: {
    component: SquareImageCard2
  },
  c5: {
    component: PortraitImageCard1
  },
  c6: {
    component: PortraitImageCard2
  },
  c7: {
    component: PortraitImageCard3
  },
  c8: {
    component: LandscapeImageCard1
  },
  c9: {
    component: PortraitTwoImagesWithHeadline1
  },
  c10: {
    component: PortraitTwoImagesWithHeadline2
  },
  c11: {
    component: PortraitTwoImagesWithParagraph
  },
  c12: {
    component: PortraitImageCardFull2
  },
  c13: {
    component: SquareImageCardFull1
  },
  c14: {
    component: LandscapeImageCardFull1
  },
  c15: {
    component: PortraitParagraphWithTitle1
  },
  c16: {
    component: SquareParagraphWithTitle1
  },
  c17: {
    component: PortraitParagraphLarge
  },
  c18: {
    component: PortraitParagraphInTwoColumns
  },
  c19: {
    component: PortraitParagraphFull1
  },
  c20: {
    component: PortraitParagraphFull2
  },
  c21: {
    component: PortraitEndCard
  },
  c22: {
    component: SquareQuote1
  },
  c23: {
    component: SquareQuote2
  },
  c24: {
    component: {
      1: SquareNumberLarge1,
      2: SquareNumberLarge2,
      3: SquareNumberLarge3,
      4: SquareNumberLarge4
    }
  },
  c25: {
    component: PortraitSocialEmbedInstagram
  },
  c27: {
    component: PortraitSocialEmbedTwitter
  },
  c28: {
    component: PortraitSocialEmbedYoutube
  }
};
